import { render, staticRenderFns } from "./addcommercial_qdxx_edit.vue?vue&type=template&id=054e64ba&scoped=true&"
import script from "./addcommercial_qdxx_edit.vue?vue&type=script&lang=js&"
export * from "./addcommercial_qdxx_edit.vue?vue&type=script&lang=js&"
import style0 from "./addcommercial_qdxx_edit.vue?vue&type=style&index=0&id=054e64ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054e64ba",
  null
  
)

export default component.exports